<template>
  <div class="page-header">
    <div class="page-header-icon"><v-icon dark large>{{ icon }}</v-icon></div>
    <div class="page-header-text">
      <h2 class="page-header-title">{{ title }}</h2>
      <div v-if="subtitle" class="page-header-sub">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "mdi-file-document-outline" },
  },
};
</script>

<style scoped>
.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 18px 22px;
  margin-bottom: 18px;
  background: linear-gradient(120deg, #ffffff 0%, #eafaf8 55%, #0EA5A4 115%);
  border: 1px solid #cfeae7;
  border-left: 4px solid #037769;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(3, 119, 105, 0.08);
}
.page-header-icon {
  flex: 0 0 auto;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #037769;
  border-radius: 10px;
}
.page-header-title {
  font-size: var(--fs-xl);
  font-weight: 700;
  color: #037769;
  line-height: 1.2;
  margin: 0;
}
.page-header-sub {
  font-size: var(--fs-sm);
  color: #4a8a84;
  margin-top: 3px;
}
</style>
